import React from 'react'
import DemoHero from './DemoHero'
import DemoContent from './DemoContent'

const DemoPage = () => {
  return (
    <div>
        
        <DemoHero />
        <DemoContent />
    </div>
  )
}

export default DemoPage